import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import DetectDevice from "../../data/DetectDevice";

const CoursesCategory = ({ live, offline, selfpaced, specialization }) => {
  const device = DetectDevice();

  /* ✅ RESPONSIVE STATE (ADDED ONLY) */
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div>
      <div className="container sm-p-15 ">
        <div className="d-flex animation p-2 align-items-center pb-3 flex-wrap  justify-content-evenly">
          <div className="container text-center mb-5 py-1">
            <h2 className="fw-bold display-6 text-dark">
              Explore Our <span className="clr-siliconMinds-orng">Courses</span>
            </h2>
            <p
              className="text-dark mt-1 mx-auto fs-5"
              style={{ maxWidth: "650px" }}
            >
              Choose the perfect learning experience that fits your schedule,
              goals, and ambitions.
            </p>
          </div>

          {/* ================= LIVE COURSES ================= */}
          {live ? (
            <div className="col-lg-6 col-md-12 p-3">
              <Link
                to="/live-online-courses"
                style={{ textDecoration: "none" }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: isMobile ? "column" : "row",
                    background: "#fff",
                    borderRadius: "18px",
                    overflow: "hidden",
                    boxShadow: "0 20px 40px rgba(0,0,0,0.08)",
                    borderBottom: "5px solid #f58752",
                    transition: "all 0.3s ease",
                    height: "100%",
                  }}
                >
                  {/* Image */}
                  <div
                    style={{
                      width: isMobile ? "100%" : "45%",
                      minHeight: isMobile ? "200px" : "220px",
                    }}
                  >
                    <img
                      src="https://skillsuprise.com/resources/images/live-selectioned.png"
                      alt="Online Courses"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </div>

                  {/* Content */}
                  <div
                    style={{
                      width: isMobile ? "100%" : "55%",
                      padding: isMobile ? "20px" : "28px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      textAlign: isMobile ? "center" : "left",
                    }}
                  >
                    <h3
                      style={{
                        fontSize: "24px",
                        fontWeight: "700",
                        marginBottom: "10px",
                        color: "#1c1c1c",
                      }}
                    >
                      Online Courses
                    </h3>

                    <p
                      style={{
                        fontSize: "15px",
                        color: "#0f0f10",
                        lineHeight: "1.6",
                        marginBottom: "18px",
                      }}
                    >
                      Join interactive live sessions and receive expert
                      mentorship from anywhere in the world. Learn in real time
                      with peers and mentors.
                    </p>

                    <span
                      style={{
                        fontSize: "15px",
                        fontWeight: "600",
                        color: "#0d6efd",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "8px",
                        justifyContent: isMobile ? "center" : "flex-start",
                      }}
                    >
                      View more →
                    </span>
                  </div>
                </div>
              </Link>
            </div>
          ) : null}

          {/* ================= OFFLINE COURSES ================= */}
          {offline ? (
            <div className="col-lg-6 col-md-12 p-3">
              <Link to="/offline-courses" style={{ textDecoration: "none" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: isMobile ? "column" : "row",
                    background: "#fff",
                    borderRadius: "18px",
                    overflow: "hidden",
                    boxShadow: "0 20px 40px rgba(0,0,0,0.08)",
                    borderBottom: "5px solid #f58752",
                    transition: "all 0.3s ease",
                    height: "100%",
                  }}
                >
                  {/* Image */}
                  <div
                    style={{
                      width: isMobile ? "100%" : "45%",
                      minHeight: isMobile ? "200px" : "220px",
                    }}
                  >
                    <img
                      src="https://skillsuprise.com/resources/images/offline-selectioned.png"
                      alt="Offline Courses"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </div>

                  {/* Content */}
                  <div
                    style={{
                      width: isMobile ? "100%" : "55%",
                      padding: isMobile ? "20px" : "28px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      textAlign: isMobile ? "center" : "left",
                    }}
                  >
                    <h3
                      style={{
                        fontSize: "24px",
                        fontWeight: "700",
                        marginBottom: "10px",
                        color: "#1c1c1c",
                      }}
                    >
                      Offline Courses
                    </h3>

                    <p
                      style={{
                        fontSize: "15px",
                        color: "#0f0f10",
                        lineHeight: "1.6",
                        marginBottom: "18px",
                      }}
                    >
                      Engage in practical, in-person learning experiences
                      through workshops, seminars, and classroom interactions.
                    </p>

                    <span
                      style={{
                        fontSize: "15px",
                        fontWeight: "600",
                        color: "#0d6efd",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "8px",
                        justifyContent: isMobile ? "center" : "flex-start",
                      }}
                    >
                      View more →
                    </span>
                  </div>
                </div>
              </Link>
            </div>
          ) : null}

          {/* ================= OLD CODE (UNCHANGED) ================= */}

          {/* 
{specialization?
<>
<div className="col-lg-5 sm-mt-20 sm-p-0 p-2">
<div className="fade-in-bottom delay07s">
<Link className="w-100 bg-category" to="/specialization-courses">
  <div className="d-flex br-5 bg-category text-white w-100">
    <div className="p-3">
      <h2 className="secondary-text sm-18 truncate truncate1">
        Specialization Courses
      </h2>
      <p className="text-light sm-14">
        3-4 months long courses with guaranteed internship / placement opportunities.
      </p>
      <button className="btn mt-4 btn-lg btn-sm btn-primary rounded-pill">
        Browse Courses
      </button>
    </div>
    <img
      className="w-30"
      src="https://skillsuprise.com/resources/images/specialization-selectioned.png"
    />
  </div>
</Link>
</div>
</div>
</>
:null}

{selfpaced?
<>
<div className="col-lg-5 sm-mt-20 sm-p-0 p-2">
<div className="fade-in-bottom delay07s">
<Link className="w-100 bg-category" to="/selfpaced-courses">
  <div className="d-flex br-5 bg-category text-white w-100">
    <div className="p-3">
      <h2 className="secondary-text sm-18 truncate truncate1">
        Pre-recorded Courses
      </h2>
      <p className="text-light sm-14">
        Learn anytime, anywhere by watching pre-recorded course tutorials.
      </p>
      <button className="btn mt-4 btn-lg btn-sm btn-primary rounded-pill">
        Browse Courses
      </button>
    </div>
    <img
      className="w-30"
      src="https://skillsuprise.com/resources/images/selfpaced-selectioned.png"
    />
  </div>
</Link>
</div>
</div>
</>
:null}
*/}
        </div>
      </div>
    </div>
  );
};

export default CoursesCategory;
